import React, { PureComponent } from 'react';
import {
  Tab,
  Tabs,
  Grid,
  AppBar,
} from '@material-ui/core';
import PropTypes from 'prop-types';

import BackButton from '../../components/BackButton';
import AutomaticTab from '../../containers/AutomaticTabContainer';
import ManualTab from '../../containers/ManualTabContainer';

class NewPaycheck extends PureComponent {
  constructor() {
    super();

    this.state = {
      tab: 0,
    };

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event, value) {
    this.setState({ tab: value });
  }

  render() {
    const { tab } = this.state;

    return (
      <Grid container alignItems="center">
        <Grid item>
          <BackButton history={this.props.history} />
        </Grid>
        <Grid item xs={12}>
          <AppBar position="static" color="default">
            <Tabs
              fullWidth
              value={tab}
              indicatorColor="primary"
              onChange={this.handleChange}
            >
              <Tab label="Carga Automatica" />
              <Tab label="Carga Manual" />
            </Tabs>
          </AppBar>
          {tab === 0 && <AutomaticTab history={this.props.history} />}
          {tab === 1 && <ManualTab />}
        </Grid>
      </Grid>
    );
  }
}

export default NewPaycheck;

NewPaycheck.propTypes = {
  history: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/views/Paychecks/NewPaycheck.js